import { useState } from "react";

import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./MedicalNoteCancelAutoApproveWarningPopup.module.scss";

interface IMedicalNoteCancelAutoApproveWarningPopupProps {
    onClose?: () => void;
    onContinue?: (hideAutoApproveWarningPopup: boolean) => void;
}

function MedicalNoteCancelAutoApproveWarningPopup(props: IMedicalNoteCancelAutoApproveWarningPopupProps): JSX.Element {
    const { getText } = useTranslation();
    const { onClose, onContinue } = props;
    const [hideAutoApproveWarningPopup, setHideAutoApproveWarningPopup] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const popupLines = getText("MedicalNoteCancelAutoApproveWarningPopupLabel")
        .split("\\n"); // split on escaped newlines

    function handleContinue(hideAutoApproveWarningPopup: boolean): void {
        setIsLoading(true);
        onContinue(hideAutoApproveWarningPopup);
    }

    return (
        <Modal
            showX
            draggable
            showOverlay
            centerContent
            disableOverlayClose
            width={655}
            title={getText("WarningLabel")}
            onClose={onClose}
            footer={(
                <div className="p-footer">
                    <div className={styles.footer}>
                        <div className="checkbox no-margin">
                            <label>
                                <input type="checkbox" checked={hideAutoApproveWarningPopup} onChange={e => setHideAutoApproveWarningPopup(e.target.checked)} />
                                {getText("DoNotShowWarningAgainLabel")}
                            </label>
                        </div>
                        <div>
                            <button data-action="cancel" className="btn btn-default push-right-5" onClick={() => onClose()}>{getText("CancelLabel")}</button>
                            <button className="btn btn-primary" disabled={isLoading} onClick={() => handleContinue(hideAutoApproveWarningPopup)}>{getText("ContinueLabel")}</button>
                        </div>
                    </div>
                </div>
            )}
        >
            <div className="p-body">
                {popupLines.map((text, index) => <p key={`${text},${index}`} className={styles.paragraph}>{text}</p>)}
            </div>
        </Modal>
    );
}

export { MedicalNoteCancelAutoApproveWarningPopup };
